import React, { useState } from 'react';
import { socket } from '../socket';
import { useNavigate } from "react-router-dom";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/es';
import 'katex/dist/katex.min.css';

export function MyForm() {
  const [value, setValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate()

  function onSubmit(event) {
    event.preventDefault()
    setIsLoading(true)
    if (localStorage.getItem("user") && value != '') {
      socket.emit('send_message', value.trim(), { email: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).email : '1', name: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).name : '1', message: value.trim() }, (response) => {
        setIsLoading(false)
        setValue('')
        console.log(response.status)
      })
    } else {
      // navigate('/contacto')
      setIsLoading(false)
    }
  }

  const [edit, setEdit] = useState()

  return (
    <form onSubmit={onSubmit} style={{ width: '100%' }}>
      {/* <input onChange={e => setValue(e.target.value)} required onPointerDown={e => localStorage.getItem("user") ? null : navigate('/contacto')} /> */}
      <CKEditor
        onFocus={e => localStorage.getItem("user") ? null : navigate('/contacto')}
        editor={ClassicEditor}
        config={{ language: 'es', placeholder: "Descripción" }}
        data={value}
        onChange={(event, editor) => { setValue(editor.getData()) }}
      // onReady={editor => { console.log('Editor is ready to use!', editor) }}
      />
      <button className="btn" style={{ marginTop: '.1cm' }} type="submit" disabled={isLoading}><Send /></button>
      {/* <button className="btn" style={{ marginTop: '.1cm' }} type="submit" disabled={isLoading}><Send /></button> */}
      {/* <button className="btn" style={{ marginTop: '.1cm' }} type="submit" disabled={isLoading}><Send /></button> */}
    </form>
  );
}
function Send() {
  return (
    <svg fill="gray" width="35px" height="35px" viewBox="0 0 32 32" id="Outlined" xmlns="http://www.w3.org/2000/svg">
      <title />
      <g id="Fill">
        <path d="M28.11,13.32,2.13,2.1,7.44,14.85a3.05,3.05,0,0,1,0,2.3L2.13,29.88l26-11a3,3,0,0,0,0-5.51ZM27.31,17,5.87,26.12l3.41-8.2A4.42,4.42,0,0,0,9.56,17H20V15H9.56a4.42,4.42,0,0,0-.28-.92L5.87,5.9l21.45,9.25a1,1,0,0,1,.6.92A1,1,0,0,1,27.31,17Z" />
      </g>
    </svg>
  )
}
